import React from 'react';
import { useSpring, animated, config } from '@react-spring/web';

import { chartColors } from '../../config/colors';

interface HintProps {
    text: string;
    scalingFactor?: number;
    transform?: string;
}

export const Hint: React.FC<HintProps> = ({ text, scalingFactor = 1, transform = '' }) => {
    const moveAnimation = useSpring({
        config: {
            duration: 1000,
            easing: t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)
        },
        loop: true,
        from: { transform: 'translate(0, 10)', fillOpacity: 1 },
        to: [
            { transform: 'translate(300, 50)', fillOpacity: 0.5 },
            { transform: 'translate(600, -20)', fillOpacity: 0 }
        ]
    });

    return (
        <g className="user-hint" transform={transform}>
            <text
                fontFamily="'Open Sans', OpenSans, sans-serif"
                fontSize={14 * scalingFactor}
                fontWeight="300"
                fill={chartColors.fontPrimary}
            >
                {text}
            </text>
            <animated.path
                {...moveAnimation}
                fill={chartColors.fontPrimary}
                d="M20.5 28.7h-11c-.5 0-.9-.4-.9-.9 0-1.4-.7-2.3-1.7-3.5-.5-.7-1.2-1.5-1.8-2.4-1.7-2.8-3.2-6-3.6-7.3-.4-1.3-.1-2 .2-2.4.4-.6 1.1-.9 1.9-.9 1.1 0 2.3.9 3.2 2.1V3.9c0-1.5 1.3-2.8 2.7-2.8 1.5 0 2.8 1.3 2.8 2.8v3.9c.3-.1.5-.2.9-.2 1 0 1.8.5 2.3 1.3.4-.2.9-.4 1.3-.4 1.3 0 2.3.9 2.6 2 .3-.1.6-.2 1-.2 1.5 0 2.8 1.3 2.8 2.8v2.8c0 2.3-.5 4.3-.9 6.1-.5 1.9-.9 3.6-.9 5.8.1.4-.4.9-.9.9zm-10.1-1.8h9.3c.1-2 .5-3.7.9-5.3.5-1.8.9-3.6.9-5.7V13c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-2.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9v2c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-2.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9v2c0 .5-.4.9-.9.9s-.9-.4-.9-.9V3.7c0-.5-.4-.9-.9-.9s-1.2.4-1.2.9v14c0 .5-.4.9-.9.9s-.9-.4-.9-.9V17c-.8-2.1-2.6-4-3.2-4-.2 0-.4.1-.4.2-.1.1-.1.4 0 .8.3 1 1.7 4 3.5 6.8.6.9 1.2 1.6 1.7 2.3.9 1.2 1.7 2.3 2 3.8z"
            />
        </g>
    );
};
